import React from "react"
import { Tag } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconDefinition } from "@fortawesome/fontawesome-svg-core"

interface FormatPanelHeaderProps {
  icon: IconDefinition
  title: string
  tagLabel: string
  tagColor: string
  description: string
}

const FormatPanelHeader: React.FC<FormatPanelHeaderProps> = ({
  icon,
  title,
  tagLabel,
  tagColor,
  description,
}) => (
  <div className="mb-4">
    <div className="flex items-center gap-2 mb-1">
      <FontAwesomeIcon icon={icon} className="text-base text-[#36c3ed]" />
      <span className="text-lg font-semibold text-gray-800">{title}</span>
      <Tag color={tagColor}>{tagLabel}</Tag>
    </div>
    <p className="text-sm text-gray-500 m-0">{description}</p>
  </div>
)

export default FormatPanelHeader
